import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";
import { element } from "prop-types";

const ChargebackAddEdit = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const inventorydata = JSON.parse(localStorage.getItem("chargeback"));
	fileName = `${outbounddata.VendorName} Chargebacks Source Data (EDI)`;
	if (outbounddata.TaskTypeCode === "OctapharmaChargebacks") {
		inventorydata.map((element) => {
			element.HIN = element.ShipToHIN;
		});
	}

	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [gridSales, setGridSales] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	const [gridShow, setGridShow] = useState(false);
	// const [cont, setCont] = useState({});
	const [chargeback, setChargeBack] = useState({});
	const [indicator, setIndicator] = useState(false);
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const [disableSaveAll, setDisableSaveAll] = useState(false);
	const initialvalues = {
		ChargebackAmount: "",
		ContractID: "",
		ContractPricePerPkg: "",
		DebitMemo: "",
		DistributorHIN: "",
		DistributorName: "",
		FileProcessID: "",
		HIN: "",
		InvoiceDate: "",
		InvoiceID: "",
		OrigWACPricePerPkg: "",
		ProductDescription: "",
		ProductNDC: "",
		Quantity: "",
		ShipToAddress: "",
		ShipToCity: "",
		ShipToHIN: "",
		ShipToName: "",
		ShipToState: "",
		ShipToZipCode: "",
		TotalAmountClaimed: "",
		TotalAmountRequested: "",
		TotalLineCount: "",
		UnitOfMeasure: "",
	};
	const [newSales, setNewSales] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	//
	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			accessor: "accessor",

			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					{outbounddata.ServiceTaskID === 575 &&
					outbounddata.Isrejected ? null : (
						<Button
							variant="link"
							onClick={() => deleteRecord(row)}
							className="grid-action-btn ml-2"
							title="Delete Row"
						>
							<IoMdTrash className="icon fa-icon" />
						</Button>
					)}
				</Fragment>
			),
		},
		{
			Header: "Distributor Name",
			accessor: "DistributorName",
			filter: "DistributorName",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Distributor HIN #",
			accessor: "DistributorHIN",
			filter: "DistributorHIN",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Debit Memo/Document #",
			accessor: "DebitMemo",
			filter: "DebitMemo",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Total line count",
			accessor: "TotalLineCount",
			filter: "TotalLineCount",
			// key: true,
			sortType: "basic",
			disable: true,
		},
		{
			Header: "Total Amount Requested",
			accessor: "TotalAmountRequested",
			filter: "TotalAmountRequested",
			// key: true,
			sortType: "basic",
			disable: true,
		},
		{
			Header: "340B ID/ HIN",
			accessor: "HIN",
			filter: "HIN",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Invoice Date",
			accessor: "InvoiceDate",
			filter: "InvoiceDate",
			key: true,
			sortType: "basic",
			width: 110,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Invoice #",
			accessor: "InvoiceID",
			filter: "InvoiceID",
			key: true,
			sortType: "basic",
			width: 90,
		},
		{
			Header: "Product NDC-11",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			key: true,
			sortType: "basic",
			width: 130,
		},
		{
			Header: "Product Description",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Contract ID #",
			accessor: "ContractID",
			filter: "ContractID",
			key: true,
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Qty",
			accessor: "Quantity",
			filter: "Quantity",
			key: true,
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Orig WAC Price Per Pkg",
			accessor: "OrigWACPricePerPkg",
			filter: "OrigWACPricePerPkg",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Contract Price Per Pkg",
			accessor: "ContractPricePerPkg",
			filter: "ContractPricePerPkg",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Chargeback Amount (Ext Total)",
			accessor: "ChargebackAmount",
			filter: "ChargebackAmount",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Total Amount Claimed",
			accessor: "TotalAmountClaimed",
			filter: "TotalAmountClaimed",
			// key: true,
			sortType: "TotalAmountClaimed",
			disable: true,
		},
		{
			Header: "Ship To Address",
			accessor: "ShipToAddress",
			filter: "ShipToAddress",
			key: true,
			sortType: "basic",
			width: 260,
		},
		{
			Header: "Ship To City",
			accessor: "ShipToCity",
			filter: "ShipToCity",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Ship To Name",
			accessor: "ShipToName",
			filter: "ShipToName",
			key: true,
			sortType: "basic",
			width: 300,
		},
		{
			Header: "Ship To State",
			accessor: "ShipToState",
			filter: "ShipToState",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Ship To ZipCode",
			accessor: "ShipToZipCode",
			filter: "ShipToZipCode",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Unit Of Measure",
			accessor: "UnitOfMeasure",
			filter: "UnitOfMeasure",
			key: true,
			sortType: "basic",
		},
	];

	useEffect(() => {
		setGridSales(inventorydata);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "InvoiceID" ||
			name === "Quantity" ||
			name === "OrigWACPricePerPkg" ||
			name === "ContractPricePerPkg" ||
			name === "ChargebackAmount" ||
			name === "TotalAmountClaimed" ||
			name === "TotalAmountRequested" ||
			name === "ProductNDC" ||
			name === "ShipToZipCode"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setChargeBack((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setChargeBack((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	const newhandleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "InvoiceID" ||
			name === "Quantity" ||
			name === "OrigWACPricePerPkg" ||
			name === "ContractPricePerPkg" ||
			name === "ChargebackAmount" ||
			name === "TotalAmountClaimed" ||
			name === "TotalAmountRequested" ||
			name === "ProductNDC" ||
			name === "ShipToZipCode"
		) {
			const re = /^[($)\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewSales((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			console.log(e);
			setNewSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	function copyReport(row) {
		// delete gridSales[row.row.index];
		let obj = Object.assign({}, row);
		obj.ind = gridSales.length + 1;
		const row1 = Object.assign({}, obj);
		gridSales.push(row1);
		const deletedData = Object.assign([], gridSales);
		setGridSales(deletedData);
	}

	function deleteRecord(row) {
		// delete gridSales[row.row.index];
		let data = gridSales.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridSales(deletedData);
	}

	const handleChangeDate = (date, i) => {
		const re = i;
		setChargeBack((values) => ({
			...values,
			ReportingDate: date,
		}));
	};

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newSales]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [chargeback]);

	const validateEditForm = () => {
		chargeback.ContractID = chargeback.ContractID ? chargeback.ContractID : "";
		chargeback.ShipToAddress = chargeback.ShipToAddress
			? chargeback.ShipToAddress
			: "";
		chargeback.ShipToCity = chargeback.ShipToCity ? chargeback.ShipToCity : "";
		chargeback.ShipToName = chargeback.ShipToName ? chargeback.ShipToName : "";
		chargeback.ShipToState = chargeback.ShipToState
			? chargeback.ShipToState
			: "";
		chargeback.ShipToZipCode = chargeback.ShipToZipCode
			? chargeback.ShipToZipCode
			: "";
		chargeback.UnitOfMeasure = chargeback.UnitOfMeasure
			? chargeback.UnitOfMeasure
			: "";
		chargeback.HIN = chargeback.HIN ? chargeback.HIN : "";
		if (
			chargeback.DistributorName &&
			chargeback.DistributorName.toString().trim() !== "" &&
			(chargeback.ChargebackAmount || chargeback.ChargebackAmount === 0) &&
			chargeback.ChargebackAmount.toString().trim() !== "" &&
			chargeback.ContractID &&
			chargeback.ContractID.toString().trim() !== "" &&
			(chargeback.ContractPricePerPkg ||
				chargeback.ContractPricePerPkg === 0) &&
			chargeback.ContractPricePerPkg.toString().trim() !== "" &&
			chargeback.DebitMemo &&
			chargeback.DebitMemo.toString().trim() !== "" &&
			chargeback.DistributorHIN &&
			chargeback.DistributorHIN.toString().trim() !== "" &&
			chargeback.HIN &&
			chargeback.HIN.toString().trim() !== "" &&
			chargeback.InvoiceID &&
			chargeback.InvoiceID.toString().trim() !== "" &&
			(chargeback.OrigWACPricePerPkg || chargeback.OrigWACPricePerPkg === 0) &&
			chargeback.OrigWACPricePerPkg.toString().trim() !== "" &&
			chargeback.ProductDescription &&
			chargeback.ProductDescription.toString().trim() !== "" &&
			chargeback.ProductNDC &&
			chargeback.ProductNDC.toString().trim() !== "" &&
			(chargeback.Quantity || chargeback.Quantity === 0) &&
			chargeback.Quantity.toString().trim() !== "" &&
			chargeback.ShipToAddress &&
			chargeback.ShipToAddress.toString().trim() !== "" &&
			chargeback.ShipToCity &&
			chargeback.ShipToCity.toString().trim() !== "" &&
			chargeback.ShipToName &&
			chargeback.ShipToName.toString().trim() !== "" &&
			chargeback.ShipToState &&
			chargeback.ShipToState.toString().trim() !== "" &&
			chargeback.ShipToZipCode &&
			chargeback.ShipToZipCode.toString().trim() !== "" &&
			chargeback.UnitOfMeasure &&
			chargeback.UnitOfMeasure.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	const validateForm = () => {
		if (
			newSales.DistributorName &&
			newSales.toString().trim() !== "" &&
			(newSales.ChargebackAmount || newSales.ChargebackAmount === 0) &&
			newSales.toString().trim() !== "" &&
			newSales.ContractID &&
			newSales.toString().trim() !== "" &&
			(newSales.ContractPricePerPkg || newSales.ContractPricePerPkg === 0) &&
			newSales.toString().trim() !== "" &&
			newSales.DebitMemo &&
			newSales.toString().trim() !== "" &&
			newSales.DistributorHIN &&
			newSales.toString().trim() !== "" &&
			newSales.HIN &&
			newSales.toString().trim() !== "" &&
			newSales.InvoiceID &&
			newSales.toString().trim() !== "" &&
			(newSales.OrigWACPricePerPkg || newSales.OrigWACPricePerPkg === 0) &&
			newSales.toString().trim() !== "" &&
			newSales.ProductDescription &&
			newSales.toString().trim() !== "" &&
			newSales.ProductNDC &&
			newSales.toString().trim() !== "" &&
			(newSales.Quantity || newSales.Quantity === 0) &&
			newSales.toString().trim() !== "" &&
			newSales.ShipToAddress &&
			newSales.toString().trim() !== "" &&
			newSales.ShipToCity &&
			newSales.toString().trim() !== "" &&
			newSales.ShipToName &&
			newSales.toString().trim() !== "" &&
			newSales.ShipToState &&
			newSales.toString().trim() !== "" &&
			newSales.ShipToZipCode &&
			newSales.toString().trim() !== "" &&
			newSales.UnitOfMeasure &&
			newSales.toString().trim() !== ""
		) {
			return false;
		} else {
			return true;
		}
	};

	function saveRowHandler() {
		if (!editOrSaveInd) {
			newSales.InvoiceDate = moment(
				newSales.InvoiceDate ? newSales.InvoiceDate : new Date()
			).format("MM/DD/YYYY");
			newSales.ind = Object.assign({}, gridSales.length + 1);
			newSales.ind = gridSales.length + 1;
			const ns = Object.assign({}, newSales);
			gridSales.unshift(ns);
			setaddShowConfirm(false);
			setNewSales(initialvalues);
			newSales.ind = 0;
		}
	}

	function editRowHandler() {
		let indicator = 0;
		chargeback.InvoiceDate = moment(chargeback.InvoiceDate).format(
			"MM/DD/YYYY"
		);
		if (chargeback.DistributorName && chargeback.DistributorName) {
			if (editOrSaveInd) {
				gridSales.filter((element, index) => {
					if (editIndex === index) {
						const cbk = Object.assign({}, chargeback);
						gridSales[index] = cbk;
					}
				});
			}
			indicator = 1;
		}
		if (indicator !== 0) {
			console.log(chargeback);
			setShowConfirm(false);
			setIndicator(false);
		} else {
			setIndicator(true);
		}
	}

	const editReport = (contacts) => {
		setEditIndex(contacts.row.index);
		setChargeBack(
			{
				...chargeback,
				...contacts.row.original,
			},
			setAddSubmitDisable(validateEditForm())
		);
		setShowConfirm(true);
		setEditOrSaveInd(true);
		setAddSubmitDisable(validateEditForm());
	};

	const EditRecords = () => {
		setGridShow(true);
	};

	const saveRecords = () => {
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		setDisableSaveAll(true);
		gridSales.map((element) => {
			element.FileProcessID = outbounddata.FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus === "Sent" ||
				outbounddata.FileSentStatus === "Rejected"
					? true
					: false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
			element.ShipToHIN =
				outbounddata.TaskTypeCode === "OctapharmaChargebacks"
					? element.HIN
					: element.ShipToHIN;
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/Reversal844Chargeback", gridSales)
			.then((data) => {
				if (data.data === "") {
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
					setLoading(false);
				}
			})
			.catch((e) => {
				setLoading(false);
				setDisableSaveAll(false);
			});
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					{!gridShow ? (
						outbounddata.ServiceTaskID === 575 &&
						outbounddata.Isrejected ? null : (
							<Button
								variant="primary"
								type="button"
								onClick={() => saveRecords()}
							>
								Add Record
							</Button>
						)
					) : null}

					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridSales, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>

				<Modal
					show={addshowConfirm}
					onHide={() => setaddShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Add Record</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={newSales[i.accessor]}
																				selected={
																					newSales[i.accessor]
																						? new Date(
																								moment(
																									newSales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newSales[i.accessor]}
																				key={chargeback[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setaddShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>

				<Modal
					show={showCOnfirm}
					onHide={() => setShowConfirm(false)}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Edit Record</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.Header.indexOf("Date") !== -1 && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.Header.indexOf("Date") !== -1 && (
																			<DatePicker
																				key={chargeback[i.accessor]}
																				selected={
																					chargeback[i.accessor]
																						? new Date(
																								moment(
																									chargeback[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setChargeBack((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={new Date()}
																			/>
																		)}
																		{i.Header.indexOf("Date") === -1 && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={chargeback[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => setShowConfirm(false)}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			{gridShow && (
				<Row>
					<Col md={12}>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{sales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={sales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			{!gridShow && (
				<Row>
					<Col md={12}>
						<span className="mb-4 h6">
							File Name: {outbounddata.File_Process_Name}
						</span>{" "}
						<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{gridSales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={gridSales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridSales.length > 0 && (
						<Button
							variant="primary"
							type="button"
							disabled={disableSaveAll}
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => {
							localStorage.removeItem("chargeback");
							history.goBack();
						}}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default ChargebackAddEdit;
